import { createStrictContext } from 'utils/createContext'
import { useGetUsersTableDataQuery } from 'schema'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { useCIMSModalValues } from 'components/CIMSModal/hooks/useCIMSModal'
import { User, UsersTableContext } from './types'
import { useProjectContext } from 'context/ProjectContext'

const { Provider, useContextFn } =
  createStrictContext<UsersTableContext>('UsersTableContext')

export const useUsersTableContext = useContextFn

export const UsersTableProvider: React.FC = ({ children }) => {
  const { projectId } = useProjectContext()

  const {
    data,
    refetch,
    loading: fetching,
  } = useGetUsersTableDataQuery({
    ...DefaultQueryHookOptions,
    variables: {
      projectId,
    },
  })
  return (
    <Provider
      value={{
        records: data?.project?.users ?? [],
        refetch,
        fetching,
        roles: data?.project?.roles ?? [],
        userGroups:
          data?.project?.projectToUserGroups.map(
            ({ userGroup }) => userGroup
          ) ?? [],
        customFields: data?.project?.customFields ?? [],
        editModal: useCIMSModalValues<User>(),
      }}
    >
      {children}
    </Provider>
  )
}
